// import React, { useState, useEffect, useRef } from 'react';
// import './Cfilter.css';

// const Cfilter = ({ options, value, onChange, placeholder }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [isFocused, setIsFocused] = useState(false);
//     const selectRef = useRef(null);

//     const handleToggle = () => {
//         setIsOpen(!isOpen);
//         setIsFocused(!isOpen);
//     };

//     const handleOptionChange = (option) => {
//         const newValues = value.includes(option.value)
//             ? value.filter((val) => val !== option.value)
//             : [...value, option.value];

//         onChange(newValues);
//     };

//     const handleClear = () => {
//         onChange([]); // Clear all selected values
//     };

//     const handleClickOutside = (event) => {
//         if (selectRef.current && !selectRef.current.contains(event.target)) {
//             setIsOpen(false);
//             setIsFocused(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const getLabelForValue = (value) => {
//         for (const section of options) {
//             const found = section.items.find((item) => item.value === value);
//             if (found) return found.label;
//         }
//         return value;
//     };

//     return (
//         <div className="customSelect" ref={selectRef}>
//             <div className={`custom-select__header ${isFocused ? 'focused' : ''}`} onClick={handleToggle}>
//                 {/* {value.length > 0 ? value.map(getLabelForValue).join(', ') : placeholder} */}
//                 {placeholder}
//             </div>
//             {isOpen && (
//                 <div className="custom-select__dropdown">
//                     <div className="custom-select__options">
//                         {options.map((section) => (
//                             <div key={section.title} className="custom-select__section">
//                                 <div className="custom-select__section-title">{section.title}</div>
//                                 {section.items.map((option) => (
//                                     <div key={option.value} className="custom-select__option">
//                                         <input
//                                             type="checkbox"
//                                             id={option.value}
//                                             checked={value.includes(option.value)}
//                                             onChange={() => handleOptionChange(option)}
//                                         />
//                                         <label style={{ cursor: "pointer" }} htmlFor={option.value}>{option.label}</label>
//                                     </div>
//                                 ))}
//                             </div>
//                         ))}
//                     </div>
//                     <div className="custom-select__clear">
//                         <button className="custom-select__clear-btn" onClick={handleClear}>
//                             Clear
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Cfilter;


//new ui filter
import React, { useState, useRef, useEffect } from 'react';
import './Cfilter.css';
import { FiFilter } from 'react-icons/fi';

const Cfilter = ({ 
  options, 
  value, 
  onChange, 
  placeholder,
  style 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [tempValue, setTempValue] = useState(value);
  const selectRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen && options.length > 0) {
      setActiveSection(options[0]?.title);
      setTempValue(value);
    }
  };

  const handleTempOptionChange = (option) => {
    const newValues = tempValue.includes(option)
      ? tempValue.filter((val) => val !== option)
      : [...tempValue, option];
    setTempValue(newValues);
  };

  const handleClear = () => {
    setTempValue([]);
    onChange([]);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const hasActiveFilters = () => {
    return tempValue.length > 0;
  };

  const getFilterCount = (sectionTitle) => {
    const section = options.find(opt => opt.title === sectionTitle);
    if (!section) return 0;

    return tempValue.filter(val =>
      section.items.some(item => item.value === val)
    ).length;
  };

  const getActiveSectionItems = () => {
    if (!activeSection) return [];
    const section = options.find(opt => opt.title === activeSection);
    return section ? section.items : [];
  };

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  return (
    <div className="cfilter-container" style={style}>
      <div
        className={`cfilter-header ${hasActiveFilters() ? 'has-filters' : ''}`}
        onClick={handleToggle}
      >
        <FiFilter className="cfilter-icon" size={24} />
        <span className="cfilter-placeholder">
          {placeholder}
          {hasActiveFilters() && (
            <span className="cfilter-count-badge">
              {tempValue.length}
            </span>
          )}
        </span>
      </div>

      {isOpen && (
        <div className="cfilter-overlay">
          <div className="cfilter-panel" style={{ width: '700px' }} ref={selectRef}>
            <div className="cfilter-sidebar">
              <div className="cfilter-title">Filters</div>
              {options.map((section) => {
                const count = getFilterCount(section.title);
                return (
                  <div
                    key={section.title}
                    className={`cfilter-sidebar-item ${activeSection === section.title ? 'active' : ''}`}
                    onClick={() => setActiveSection(section.title)}
                  >
                    <span>{section.title}</span>
                    {count > 0 && <span className="cfilter-badge">{count}</span>}
                  </div>
                );
              })}
            </div>

            <div className="cfilter-main">
              <div className="cfilter-actions">
                <button
                  className="cfilter-clear-btn"
                  onClick={handleClear}
                  disabled={!hasActiveFilters()}
                >
                  CLEAR ALL
                </button>
                <button
                  className="cfilter-apply-btn"
                  onClick={() => {
                    onChange(tempValue);
                    setIsOpen(false);
                  }}
                >
                  APPLY
                </button>
              </div>

              <div className="cfilter-scrollable">
                {activeSection && (
                  <>
                    <div className="cfilter-section">
                      <div className="cfilter-section-title">{activeSection}</div>
                    </div>
                    <div className="cfilter-options">
                      {getActiveSectionItems().length === 0 ? (
                        <div className="cfilter-no-results">No options available</div>
                      ) : (
                        getActiveSectionItems().map((option) => (
                          <div key={option.value} className="cfilter-option">
                            <input
                              type="checkbox"
                              id={`cfilter-${option.value}`}
                              checked={tempValue.includes(option.value)}
                              onChange={() => handleTempOptionChange(option.value)}
                            />
                            <label htmlFor={`cfilter-${option.value}`}>
                              {option.label}
                            </label>
                          </div>
                        ))
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cfilter;